import api from '../config/api';
import { network } from '../utils';

const getUdc = async (params) => {
  return await network({
    url: api.common.udc,
    method: 'get',
    params: { udcType: params },
  });
};

export default getUdc;
